import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { HelpCircle, Info } from "lucide-react";

export const FAQSection = ({ showAboutLink = true }: { showAboutLink?: boolean }) => {
    const faqs = [
        {
            question: "כיצד עובדת קבוצת רכישה?",
            answer: "קבוצת רכישה מאפשרת לכם להצטרף לרוכשים נוספים כדי להשיג כוח קנייה משמעותי. אנו מגדירים יעד כמותי, וברגע שמגיעים אליו - ההזמנה יוצאת לפועל. אם לא מגיעים ליעד, כספכם מוחזר במלואו. זו הדרך הטובה ביותר להשיג מחירים ללא תחרות.",
        },
        {
            question: "מהי מכירת חיסול (Liquidation)?",
            answer: "מכירות חיסול הן הזדמנות לרכוש עודפי מלאי, מוצרים מתצוגה או סדרות קודמות במחירים נמוכים במיוחד. המוצרים חדשים ותקינים (אלא אם צוין אחרת), ונמכרים בשיטת 'כל הקודם זוכה' עד גמר המלאי.",
        },
        {
            question: "תוך כמה זמן אקבל את ההזמנה?",
            answer: (
                <div className="space-y-2">
                    <p>זמני האספקה משתנים בהתאם לסוג המכירה:</p>
                    <ul className="list-disc list-inside space-y-1">
                        <li><strong>מכירה רגילה:</strong> אספקה מיידית תוך מספר ימי עסקים בודדים.</li>
                        <li><strong>מכירת חיסול:</strong> אספקה מיידית לאחר הגעה ליעד המכירה (השלמת כמות המינימום).</li>
                        <li><strong>קבוצת רכישה:</strong> מכיוון שמדובר ביבוא משותף, האספקה לרוב בין 30 ל-60 יום מהגעה ליעד. תאריך משוער מופיע בעמוד המוצר.</li>
                    </ul>
                </div>
            ),
        },
        {
            question: "האם יש אחריות על המוצרים?",
            answer: "כן, כל המוצרים באתר עוברים בדיקת איכות קפדנית. תקופת האחריות משתנה בהתאם לסוג המוצר והיצרן, ומופיעה בבירור בעמוד המכירה של כל פריט.",
        },
        {
            question: "האם ניתן להחזיר מוצרים?",
            answer: "כן, בהתאם לחוק הגנת הצרכן ניתן להחזיר מוצרים תוך 14 יום מקבלתם, כשהם באריזתם המקורית ולא נעשה בהם שימוש. שימו לב: במכירות חיסול או הזמנות מיוחדות ייתכנו תנאים שונים המפורטים בתקנון האתר.",
        },
        {
            question: "האם התשלום באתר מאובטח?",
            answer: "בוודאי. אנו משתמשים בפרוטוקולי אבטחה מתקדמים (PCI DSS) ואיננו שומרים את פרטי האשראי שלכם. הסליקה מתבצעת באופן מוצפן ומאובטח דרך ספק שירותי סליקה מוביל.",
        },
    ];

    return (
        <section className="py-16 bg-muted/30">
            <div className="container max-w-4xl mx-auto px-4">
                <div className="text-center mb-10">
                    <div className="flex justify-center mb-4">
                        <div className="bg-primary/10 p-3 rounded-full">
                            <HelpCircle className="w-8 h-8 text-primary" />
                        </div>
                    </div>
                    <h2 className="text-3xl font-bold mb-4">שאלות נפוצות</h2>
                    <p className="text-muted-foreground">
                        כל מה שרציתם לדעת על תהליך הרכישה, המשלוחים והאחריות
                    </p>
                </div>

                <Accordion type="single" collapsible className="w-full bg-background rounded-xl shadow-sm border px-4 md:px-6">
                    {faqs.map((faq, index) => (
                        <AccordionItem key={index} value={`item-${index}`} className="border-b-muted last:border-0">
                            <AccordionTrigger className="text-right text-lg font-medium hover:no-underline hover:text-primary py-4">
                                {faq.question}
                            </AccordionTrigger>
                            <AccordionContent className="text-muted-foreground leading-relaxed text-base pb-4">
                                {faq.answer}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>

                {showAboutLink && (
                    <div className="mt-10 text-center">
                        <Button asChild variant="outline" size="lg" className="group">
                            <Link to="/about">
                                <Info className="ml-2 h-4 w-4" />
                                למידע נוסף עלינו
                            </Link>
                        </Button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default FAQSection;
